import React from "react"
import { components, elements } from "../views/DefaultMarkdown"
import { getCompiler } from "utils/MarkdownCompile"
import PropTypes from "prop-types"
import { TextLink } from "../views/atoms/links/TextLink"
import styled from "styled-components"
import { ZendeskTextLink } from "../views/atoms/links/ZendeskTextLink"
import { isZendeskLink } from "carrot-api/HelpCenterClient"
import { reportErrorMessage } from "../../utils/ErrorReporting"
import { isInternalLink } from "../dynamic-content/DynamicContentMarkdown"

const libraryElements = {
  ...elements,
  p: ({ children }) => <p className="lh-copy gotham black-80 mt0 mb3">{children}</p>,
  a: ({ href, children, title }) => {
    if (!href) {
      reportErrorMessage(`Empty href found in Markdown with title ${title} and children ${JSON.stringify(children)}`)
    }
    if (isZendeskLink(href)) {
      return (
        <ZendeskTextLink target="_blank" title={title} to={href}>
          {children}
        </ZendeskTextLink>
      )
    }
    const target = isInternalLink(href) ? "_self" : "_blank"
    return (
      <TextLink target={target} title={title} to={href}>
        {children}
      </TextLink>
    )
  },
  h4: ({ children }) => <h4 className="b gotham black-80 mb2 mt4 f6">{children}</h4>,
  h3: ({ children }) => <h3 className="b gotham black-80 mb2 mt4 f5">{children}</h3>,
  h2: ({ children }) => <h2 className="b gotham black-80 mb2 mt4 f4">{children}</h2>,
  li: styled.li.attrs({ className: "gotham lh-copy" })`
    margin: 8px 0 8px 0;
    *:first-child {
      display: inline;
    }
  `
}

const md = getCompiler(libraryElements, components)

const LibraryMarkdown = ({ additionalClasses, source }) => (
  <div className={`m0-first-last-child ${additionalClasses ? additionalClasses : ""}`}>{md(source)}</div>
)

LibraryMarkdown.propTypes = {
  source: PropTypes.string.isRequired,
  additionalClasses: PropTypes.string
}

export default LibraryMarkdown
